import React from 'react';
import { CellType } from '../game/Game';
import { Cell } from './Cell';

interface GridProps {
  matrix: CellType[][];
  cellSize: number;
}

export const Grid: React.FC<GridProps> = ({ matrix, cellSize }) => {
  const width = Math.max(...matrix.map(row => row.length));

  return (
    <div
      style={{
        display: 'inline-grid',
        gridTemplateColumns: `repeat(${width}, ${cellSize}px)`,
        gap: '0',
        border: '4px solid #4a4a4a',
        backgroundColor: '#4a4a4a',
      }}
    >
      {matrix.map((row, y) =>
        Array.from({ length: width }).map((_, x) => (
          <Cell key={`${x}-${y}`} type={row[x] || ' '} size={cellSize} />
        ))
      )}
    </div>
  );
};